import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { field_color_theme } from 'framework/field/constants';
import { Icon } from 'framework/Icon';
import { Tooltip } from 'framework/Tooltip';

import { EMPTY_FUNCTION } from '../../constants';

import { useLabelTheme } from './hooks/useLabelTheme';
import { LabelElement } from './elements';
import { LabelProps } from './types';

import cn from './Label.module.scss';

export const Label = ({
  label,
  information = '',
  padding = '0px',
  button = false,
  onClick = EMPTY_FUNCTION,
  onMouseDown = EMPTY_FUNCTION,
  theme,
}: LabelProps) => {
  const label_theme = useLabelTheme(theme);
  if (!label) return null;

  return (
    <LabelElement
      className={cn.label}
      onClick={onClick}
      onMouseDown={(e) => onMouseDown(e, 'label')}
      theme={label_theme}
      padding={padding}
      button={button}
    >
      <label>{label}</label>
      {information && (
        <Tooltip information={information} width="200px">
          <Icon
            icon={faCircleInfo}
            width="fit-content"
            size="11px"
            theme={{ normal: field_color_theme.hover }}
          />
        </Tooltip>
      )}
    </LabelElement>
  );
};
